import React from 'react'

const MY600 = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Yokogawa</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Handheld Instruments </span>
                        <i class="fa fa-angle-right"></i>
                        <span>MY600 Digital Insulation Tester</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/my6.png' width={400} style={{ marginLeft: "90px" }}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>MY600 Digital
                            Insulation Tester:</h2>
                        <p class="mbot25">
                            The MY600 Digital Insulation Tester has enhanced operation
                            compared to the conventional model, by using a shortened measurement
                            time and color indicating judging function. This is a new concept in
                            insulation testing and includes enhanced communication to a PC or tablet.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default MY600
